export default __webpack_public_path__ + "static/media/enter-point-speeding.006d584e.svg";